/* Native page scroll is the timeline. No wheel interception, autoplay, or idle loop. */
(function () {
  'use strict';
  if (window.bbScrollStoryBoot) { window.bbScrollStoryBoot(document); return; }
  var clamp = function (n, low, high) { return Math.max(low, Math.min(high, n)); };
  var mix = function (a, b, t) { return a + (b - a) * t; };
  var ease = function (t) { t = clamp(t, 0, 1); return t * t * (3 - 2 * t); };
  var range = function (p, a, b) { return ease((p - a) / (b - a)); };
  var lerpColor = function (a, b, t) { return 'rgb(' + a.map(function (v, i) { return Math.round(mix(v, b[i], t)); }).join(',') + ')'; };
  var stops = [0, 0.345, 0.605, 0.96];
  var boundaries = [0.205, 0.48, 0.755];
  // Each ingredient has a different path, depth and rotation. Eight photographic cutouts total, never an unbounded particle system.
  var paths = [
    [12, 20, 64, 17, -28, 38, 1.04], [82, 19, 89, 20, 36, -45, 1.03],
    [92, 56, 94, 58, -24, 70, 1.10], [15, 79, 62, 83, 26, -32, .94],
    [85, 83, 80, 76, 18, 88, 1.10], [46, 87, 60, 55, -20, -95, .94],
    [4, 49, 93, 84, 58, 105, .83], [51, 12, 68, 33, -42, 42, .91],
    [58, 76, 87, 42, 73, 143, .88]
  ];
  var mobilePaths = [
    [7, 21, 4, 17, -28, 38, .89], [91, 21, 92, 23, 36, -45, .85],
    [103, 54, 105, 56, -24, 70, .87], [8, 77, 16, 85, 26, -32, .80],
    [92, 78, 85, 82, 18, 88, .88], [46, 83, 52, 81, -20, -95, .73],
    [-4, 51, -8, 54, 58, 105, .72], [53, 13, 49, 7, -42, 42, .74],
    [53, 73, 93, 68, 73, 143, .69]
  ];

  function mount(root) {
    if (root.bbScrollStory) return;
    var stage = root.querySelector('[data-bb-story-stage]');
    var panels = Array.from(root.querySelectorAll('[data-bb-story-panel]'));
    var sprites = Array.from(root.querySelectorAll('[data-bb-story-ingredient]')).slice(0, 4);
    var meals = Array.from(root.querySelectorAll('[data-bb-story-meal]')).slice(0, 4);
    var shards = Array.from(root.querySelectorAll('[data-bb-story-shard]')).slice(0, 4);
    var chapters = root.querySelector('[data-bb-story-chapters]');
    var buttons = Array.from(root.querySelectorAll('[data-bb-story-jump]'));
    if (!stage || panels.length !== 4 || !chapters) return;
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection;
    var header = document.querySelector('[data-tf-header]');
    var frame = 0, enabled = false, dead = false, active = -1, progress = 0;
    var visible = true, top = 88, width = 1, height = 1, distance = 1;
    var originalTabs = new Map();
    panels.forEach(function (panel) {
      panel.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (el) { originalTabs.set(el, el.getAttribute('tabindex')); });
    });

    function setPanelAccess(panel, current) {
      if (current) { panel.removeAttribute('aria-hidden'); panel.removeAttribute('inert'); }
      else { panel.setAttribute('aria-hidden', 'true'); panel.setAttribute('inert', ''); }
      // Also works in older engines where inert is not implemented.
      panel.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function (el) {
        if (!current) el.setAttribute('tabindex', '-1');
        else if (originalTabs.get(el) === null) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', originalTabs.get(el));
      });
    }

    function selectPanel(index) {
      if (active === index) return;
      var old = panels[active];
      // Scrolling while tabbed into an outgoing scene must not leave focus inert.
      if (old && old.contains(document.activeElement)) buttons[index].focus({ preventScroll: true });
      active = index;
      panels.forEach(function (panel, i) {
        var current = i === index;
        panel.classList.toggle('is-current', current);
        setPanelAccess(panel, current);
      });
      buttons.forEach(function (button, i) {
        if (i === index) button.setAttribute('aria-current', 'step');
        else button.removeAttribute('aria-current');
      });
      root.dataset.storyChapter = String(index);
    }

    function paint() {
      frame = 0;
      if (!enabled || dead || !visible || document.hidden) return;
      var rect = root.getBoundingClientRect();
      progress = clamp((top - rect.top) / distance, 0, 1);
      var p = progress, burst = range(p, .115, .35), options = range(p, .43, .59), pack = range(p, .68, .93);
      var freshIn = range(p, .145, .255), freshOut = range(p, .425, .535), choiceOut = range(p, .695, .815);
      var panelOpacity = [1 - freshIn, freshIn * (1 - freshOut), freshOut * (1 - choiceOut), choiceOut];
      var index = p < boundaries[0] ? 0 : p < boundaries[1] ? 1 : p < boundaries[2] ? 2 : 3;
      selectPanel(index);
      root.style.setProperty('--story-progress', p.toFixed(4));
      root.style.setProperty('--atmosphere-y', (mix(15, -15, p)).toFixed(1) + '%');
      var bg = p < .53 ? lerpColor([255, 250, 240], [228, 237, 220], range(p, .13, .32)) : lerpColor([228, 237, 220], [255, 250, 240], range(p, .66, .89));
      root.style.setProperty('--story-bg', bg);
      panels.forEach(function (panel, i) {
        panel.style.opacity = panelOpacity[i].toFixed(4);
        panel.classList.toggle('is-transitioning', panelOpacity[i] > .001 && panelOpacity[i] < .999);
        var incoming = i === 0 ? 0 : i === 1 ? 1 - freshIn : i === 2 ? 1 - freshOut : 1 - choiceOut;
        var outgoing = i === 0 ? freshIn : i === 1 ? freshOut : i === 2 ? choiceOut : 0;
        panel.style.setProperty('--copy-y', (incoming * 38 - outgoing * 25).toFixed(1) + 'px');
      });

      // The original photograph first splits around the meal, then yields to its ingredients.
      var shardAmount = range(p, .115, .275);
      var shardOpacity = range(p, .11, .15) * (1 - range(p, .185, .32));
      root.style.setProperty('--shards-opacity', shardOpacity.toFixed(4));
      var shardVectors = [[-1, -.75], [1, -.85], [-.9, .9], [1, 1]];
      shards.forEach(function (shard, i) {
        var v = shardVectors[i];
        shard.style.transform = 'translate3d(' + (v[0] * shardAmount * width * .23).toFixed(1) + 'px,' + (v[1] * shardAmount * height * .23).toFixed(1) + 'px,0) rotate(' + (v[0] * shardAmount * 13).toFixed(2) + 'deg) scale(' + (1 + shardAmount * .25).toFixed(3) + ')';
      });

      var mobile = window.innerWidth <= 760, coordinates = mobile ? mobilePaths : paths;
      var ingredientOpacity = range(p, .145, .25) * (1 - range(p, .46, .63));
      sprites.forEach(function (sprite, i) {
        var path = coordinates[i], seedX = mobile ? 67 : 72, seedY = mobile ? 67 : 58;
        var x = mix(seedX, path[0], burst), y = mix(seedY, path[1], burst);
        x = mix(x, mobile ? 55 : 75, options); y = mix(y, mobile ? 72 : 58, options);
        var scale = mix(.10, path[6], burst) * mix(1, .09, options);
        var rotation = mix(0, path[4], burst) + options * path[5];
        sprite.style.opacity = ingredientOpacity.toFixed(4);
        sprite.style.transform = 'translate3d(' + (width * x / 100).toFixed(1) + 'px,' + (height * y / 100).toFixed(1) + 'px,0) translate(-50%,-50%) rotate(' + rotation.toFixed(1) + 'deg) scale(' + scale.toFixed(3) + ')';
      });
      // The fresh burst resolves into the four real components, then gathers into the packed delivery.
      var assembly = range(p, .435, .59), mealOpacity = range(p, .435, .555) * (1 - range(p, .765, .90));
      var mealPositions = mobile ? [[28,63],[72,62],[32,80],[73,80]] : [[65,31],[85,34],[64,68],[85,72]];
      meals.forEach(function (meal, i) {
        var target = mealPositions[i];
        var x = mix(mobile ? 50 : 72, target[0], assembly), y = mix(mobile ? 64 : 52, target[1], assembly);
        x = mix(x, mobile ? 62 : 76, pack); y = mix(y, mobile ? 74 : 64, pack);
        var scale = mix(.2, 1, assembly) * mix(1, .1, pack), rotation = (1 - assembly) * (i % 2 ? 18 : -18) + pack * (i % 2 ? -22 : 22);
        meal.style.opacity = mealOpacity.toFixed(4);
        meal.style.transform = 'translate3d(' + (width * x / 100).toFixed(1) + 'px,' + (height * y / 100).toFixed(1) + 'px,0) translate(-50%,-50%) rotate(' + rotation.toFixed(1) + 'deg) scale(' + scale.toFixed(3) + ')';
      });
      root.style.setProperty('--pack-radius', mix(5, 125, range(p, .70, .94)).toFixed(1) + '%');
      root.style.setProperty('--pack-scale', mix(1.12, 1, pack).toFixed(3));
    }

    function schedule() {
      if (!frame && enabled && visible && !dead && !document.hidden) frame = requestAnimationFrame(paint);
    }

    function cancel() { if (frame) cancelAnimationFrame(frame); frame = 0; }

    function reset() {
      cancel(); enabled = false; active = -1;
      root.classList.remove('is-scroll-story');
      root.removeAttribute('data-story-chapter');
      chapters.hidden = true;
      panels.forEach(function (panel) {
        setPanelAccess(panel, true);
        panel.classList.remove('is-current', 'is-transitioning');
        panel.style.removeProperty('opacity');
        panel.style.removeProperty('--copy-y');
      });
    }

    function measure() {
      if (dead) return;
      var short = window.innerHeight < (window.innerWidth <= 760 ? 760 : 700);
      var shouldEnable = root.dataset.bbCinema !== 'false' && !!window.IntersectionObserver && !motion.matches && !(connection && connection.saveData) && !short;
      if (!shouldEnable) { reset(); return; }
      top = header ? Math.round(header.getBoundingClientRect().height || header.offsetHeight || 88) : (window.innerWidth <= 760 ? 72 : 88);
      root.style.setProperty('--bb-story-top', top + 'px');
      root.classList.add('is-scroll-story');
      enabled = true; chapters.hidden = false;
      var rect = root.getBoundingClientRect();
      width = stage.clientWidth || rect.width || window.innerWidth;
      height = stage.offsetHeight || Math.max(1, window.innerHeight - top);
      var overflow = panels.some(function (panel) {
        var copy = panel.querySelector('.bb-story__copy');
        var style = window.getComputedStyle(panel);
        return copy && copy.scrollHeight > height - parseFloat(style.paddingTop || 0) - parseFloat(style.paddingBottom || 0);
      });
      if (overflow) { reset(); return; }
      distance = Math.max(1, (root.offsetHeight || window.innerHeight * (window.innerWidth <= 760 ? 4.2 : 4.2)) - height);
      visible = rect.bottom > 0 && rect.top < window.innerHeight;
      if (active < 0) selectPanel(0);
      schedule();
    }

    function onJump(event) {
      var button = event.target.closest('[data-bb-story-jump]');
      if (!button || !root.contains(button) || !enabled) return;
      var index = Number(button.dataset.bbStoryJump);
      if (!Number.isInteger(index) || index < 0 || index > 3) return;
      var target = window.scrollY + root.getBoundingClientRect().top - top + distance * stops[index];
      window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
    }

    function onVisibility() { if (document.hidden) cancel(); else schedule(); }
    var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        visible = entry.isIntersecting;
        if (visible) schedule(); else cancel();
      });
    }) : null;
    if (observer) observer.observe(root);
    var resizeObserver = window.ResizeObserver && header ? new ResizeObserver(measure) : null;
    if (resizeObserver) resizeObserver.observe(header);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    document.addEventListener('visibilitychange', onVisibility);
    chapters.addEventListener('click', onJump);
    if (motion.addEventListener) motion.addEventListener('change', measure);
    else if (motion.addListener) motion.addListener(measure);
    if (connection && connection.addEventListener) connection.addEventListener('change', measure);

    root.bbScrollStory = {
      refresh: measure,
      destroy: function () {
        if (dead) return;
        reset(); dead = true;
        if (observer) observer.disconnect();
        if (resizeObserver) resizeObserver.disconnect();
        window.removeEventListener('scroll', schedule);
        window.removeEventListener('resize', measure);
        document.removeEventListener('visibilitychange', onVisibility);
        chapters.removeEventListener('click', onJump);
        if (motion.removeEventListener) motion.removeEventListener('change', measure);
        else if (motion.removeListener) motion.removeListener(measure);
        if (connection && connection.removeEventListener) connection.removeEventListener('change', measure);
        delete root.bbScrollStory;
      }
    };
    measure();
  }

  function boot(scope) {
    if (scope.matches && scope.matches('[data-bb-scroll-story]')) mount(scope);
    if (scope.querySelectorAll) scope.querySelectorAll('[data-bb-scroll-story]').forEach(mount);
  }
  window.bbScrollStoryBoot = boot;
  boot(document);
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = [];
    if (event.target.matches && event.target.matches('[data-bb-scroll-story]')) roots.push(event.target);
    if (event.target.querySelectorAll) roots = roots.concat(Array.from(event.target.querySelectorAll('[data-bb-scroll-story]')));
    roots.forEach(function (root) { if (root.bbScrollStory) root.bbScrollStory.destroy(); });
  });
})();
